import { Directive, ElementRef, inject, input, OnChanges, Renderer2 } from '@angular/core';

@Directive({
  selector: '[libHighlightQuery]',
  standalone: true,
})
export class HighlightQueryDirective implements OnChanges {
  libHighlightQuery = input('');

  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  ngOnChanges() {
    this.highlightText();
  }

  private highlightText() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    const originalText = nativeElement.innerText?.trim()?.toLocaleLowerCase() || '';
    const searchQuery = this.libHighlightQuery()?.trim()?.toLocaleLowerCase();

    if (!searchQuery) {
      this.renderer.setProperty(nativeElement, 'innerHTML', originalText);
      return;
    }

    // TODO completed
  }
}
